<template>
  <span>
    <b-button @click.prevent="$bvModal.show('saca-cajas')"> Stock Bluefields </b-button>
    <b-modal
      id="saca-cajas"
      size="lg"
      title="Stock Bluefields"
      ok-title="Salir"
      ok-only
      ok-variant="secondary"
      @show="onShow"
      @hide="onHide"
    >
      <b-row>
        <b-col>
          <h3>Formulario</h3>
          <b-form class="border-top">
            <b-form-group class="mt-2" label="Formato" label-for="formato">
              <b-form-select
                id="formato"
                v-model="$v.form.formato.$model"
                :state="$v.form.formato.$dirty ? !$v.form.formato.$error : null"
                :options="formatos"
                required
              ></b-form-select>
            </b-form-group>
            <b-form-group label="Tipo" label-for="tipo">
              <b-form-select
                id="tipo"
                v-model="$v.form.tipo.$model"
                :state="$v.form.tipo.$dirty ? !$v.form.tipo.$error : null"
                :options="tipos"
                required
              ></b-form-select>
            </b-form-group>
            <b-form-group label="Cajas/Kilos" label-for="cajas">
              <b-form-input
                id="cajas"
                v-model="$v.form.cajas.$model"
                :state="$v.form.cajas.$dirty ? !$v.form.cajas.$error : null"
                type="number"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Motivo" label-for="motivo">
              <b-form-textarea id="motivo" v-model="form.motivo"></b-form-textarea>
            </b-form-group>
            <b-row>
              <b-col>
                <b-button variant="danger" block class="mb-2" @click.prevent="submitForm(1)"
                  >SACAR DEL PROCESO</b-button
                >
              </b-col>
              <b-col>
                <b-button variant="success" block class="mb-2" @click.prevent="submitForm(-1)"
                  >AGREGAR AL PROCESO</b-button
                >
              </b-col>
            </b-row>
          </b-form>
        </b-col>
        <b-col class="border-left">
          <h3>Movimientos de este proceso</h3>
          <div class="text-center">
            <b-spinner v-if="loading"></b-spinner>
            <b-table small :items="items" :fields="itemsFields" v-else>
              <template #cell(actions)="data">
                <a href="#" @click="deleteItem(data.item.id)">
                  <i class="fa fa-lg fa-trash text-danger"></i>
                </a>
              </template>
            </b-table>
          </div>
          <h3>Stock</h3>
          <div class="text-center">
            <b-spinner v-if="loading"></b-spinner>
            <b-table small :items="stock" v-else></b-table>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </span>
</template>

<script>
import { required, numeric } from "vuelidate/lib/validators";
export default {
  name: "SacaCajas",
  components: {},
  props: {
    process_id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      ready: false,
      loading: true,
      formatos: [],
      tipos: ["PT", "IQF"],
      form: {
        formato: "",
        tipo: "",
        cajas: "",
        motivo: ""
      },
      itemsFields: [
        { key: "formato", label: "Formato" },
        { key: "tipo", label: "Tipo" },
        { key: "cajas", label: "Cajas" },
        { key: "fecha", label: "Fecha" },
        { key: "motivo", label: "Motivo" },
        { key: "actions", label: "" }
      ],
      items: [],
      stock: []
    };
  },
  validations: {
    form: {
      formato: {
        required
      },
      tipo: {
        required
      },
      cajas: {
        required,
        numeric
      }
    }
  },
  methods: {
    onShow() {
      this.getFormatos();
      this.updateData();
    },
    onHide() {
      this.$v.$reset();
      this.resetForm();
      this.items = [];
    },
    resetForm() {
      this.form = {
        formato: "",
        tipo: "",
        cajas: "",
        motivo: ""
      };
      this.$v.$reset();
    },
    updateData() {
      this.getMovimientos().then(() => {
        this.getStock();
      });
    },
    async getStock() {
      this.loading = true;
      try {
        const res = await this.$axios.get("/api/v1/saca_cajas/get_stock/");
        this.stock = res.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getMovimientos() {
      this.loading = true;
      try {
        const res = await this.$axios.get("/api/v1/saca_cajas/?no_page&process_id=" + this.process_id);
        this.items = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteItem(id) {
      this.loading = true;
      try {
        await this.$axios.delete("/api/v1/saca_cajas/" + id + "/");
        this.updateData();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async submitForm(type) {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      this.loading = true;
      try {
        await this.$axios.post("/api/v1/saca_cajas/", {
          proceso: this.process_id,
          formato: this.form.formato,
          tipo: this.form.tipo,
          cajas: this.form.cajas * type,
          motivo: this.form.motivo
        });
        this.resetForm();
        this.updateData();
      } catch (error) {
        this.$bvToast.toast("Error al guardar", {
          title: "Error",
          variant: "danger",
          solid: true
        });
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getFormatos() {
      this.loading = true;
      try {
        const response = await this.$axios.get("/api/v1/container/?no_page");
        this.formatos = response.data.map((item) => item.value.name);
      } catch (error) {
        console.log(error);
        this.$bvToast.toast("Error al obtener los formatos", {
          title: "Error",
          variant: "danger",
          solid: true
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
